export default {
  placeholder: 'Wybierz przepis',
};
